import { useState } from "react";
import { Play, Download } from "lucide-react";
import { getDownloadShorts } from "../../services/shortService";
import { useToast } from "../../provider/ToastContext";

export default function ClipCard({ clip }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const { showToast } = useToast();

  const videoURL = clip.url; // single source of truth

  return (
    <>
      <div className="group rounded-2xl border border-gray-200 overflow-hidden bg-white transition-all duration-200 hover:shadow-lg hover:-translate-y-[2px]">
        {/* THUMBNAIL */}
        <div className="relative h-44 bg-black overflow-hidden">
          <img
            src={clip.thumbnail_url}
            onError={(e) => {
              e.target.src =
                "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=1200";
            }}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />

          {/* ▶️ Preview Button */}
          <button
            onClick={() => setPreviewOpen(true)}
            className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
          >
            <div className="bg-black/70 p-3 rounded-full">
              <Play size={18} className="text-white" />
            </div>
          </button>
        </div>

        {/* INFO */}
        <div className="p-4">
          <p className="text-sm text-gray-700">
            {clip.start_sec}s → {clip.end_sec}s
          </p>

          {/* Download */}
          <button
            onClick={() => getDownloadShorts(videoURL, showToast)}
            className="mt-3 inline-flex items-center gap-1 text-xs border border-gray-200 px-3 py-1.5 rounded-md hover:bg-gray-50 transition"
          >
            <Download size={12} /> Download
          </button>
        </div>
      </div>

      {/* 🎬 PREVIEW MODAL */}
      {previewOpen && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999]">
          <div className="relative">
            {/* Close */}
            <button
              onClick={() => setPreviewOpen(false)}
              className="absolute -top-10 right-0 text-white text-xl"
            >
              ✕
            </button>

            {/* Video Container (vertical format) */}
            <div className="w-[320px] h-[568px] bg-black rounded-xl overflow-hidden">
              <video
                src={videoURL}
                controls
                autoPlay
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
